import apiClient from '../apiClient';
import { GET_PARTNER_EMPLOYEE_LIST } from '../apiUrl';

const getPartnerEmployeeListApi = () => {
  return apiClient.get(GET_PARTNER_EMPLOYEE_LIST);
};

export { getPartnerEmployeeListApi };
